import { Stack, Typography } from '@mui/material';
import HomepPageList from '../../../../../Home/components/FourSolutions/components/HompageList';

const whatYouWillDo = [
  'Research and identify new potential clients and partners',
  'Reach out via LinkedIn, email, and calls to introduce Spona Performance',
  'Qualify leads and pass them to the sales or product demo team',
  'Help prepare light presales materials and follow-ups',
  'Track outreach activities in CRM and contribute to pipeline growth',
];

const whatYouBring = [
  'Motivation to start or grow a career in SaaS sales',
  'Excellent written and verbal English communication',
  'Curiosity about marketing, performance management, and digital services',
  'Self-driven attitude — you’re comfortable taking initiative',
  'Experience in outreach, sales, or agency environments is a plus (not required)',
];

const whatWeOffer = [
  <Typography>
    Irish minimum base salary +{' '}
    <Typography variant="publicBody5" component="span">
      commission per converted sale
    </Typography>
  </Typography>,
  'Opportunity to grow into a full Account Executive or Partner Manager role',
  'Training, tools, and ongoing support from our international sales team',
  'Flexible hours and remote-friendly work',
];

const SalesRepresentivePerformance = () => (
  <Stack spacing={3}>
    <Stack>
      <Typography variant="publicBody4Regular">
        <Typography component="span" variant="publicBody4">
          Location:{' '}
        </Typography>
        Remote or Hybrid (Ireland)
      </Typography>
      <Typography variant="publicBody4Regular">
        <Typography component="span" variant="publicBody4">
          Type:{' '}
        </Typography>
        Full-time, Entry to Mid-level
      </Typography>
      <Typography variant="publicBody4Regular">
        <Typography component="span" variant="publicBody4">
          Compensation:{' '}
        </Typography>
        Irish minimum base salary + uncapped commission on converted sales
      </Typography>
    </Stack>

    <Typography variant="publicBody4Regular">
      <Typography component="span" variant="publicBody4">
        Eligibility:{' '}
      </Typography>
      <Typography sx={{ fontStyle: 'italic' }} component="span">
        Applicants must currently reside in Ireland and be legally entitled to work in Ireland.
      </Typography>
    </Typography>

    <Stack>
      <Typography variant="publicBody4">About Spona</Typography>
      <Typography variant="publicBody4Regular">
        Spona is a European SaaS startup simplifying how companies manage external partners,
        projects, and performance. From marketing campaigns to complex supplier management, we help
        teams track, contract, and deliver results in one place — replacing scattered emails and
        PDFs with structure and clarity.
      </Typography>
    </Stack>

    <Stack>
      <Typography variant="publicBody4">Your Mission</Typography>
      <Typography variant="publicBody4Regular">
        As our{' '}
        <Typography variant="publicBody4" component="span">
          Sales Development Representative for Spona Performance
        </Typography>
        , you’ll be on the front line of growth — connecting with marketing managers, agencies, and
        SMBs across Ireland and Europe. Your goal: open conversations, qualify leads, and schedule
        demos that turn into long-term clients.
      </Typography>
    </Stack>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        What You'll Do:
      </Typography>
      <HomepPageList items={whatYouWillDo} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        What You Bring:
      </Typography>
      <HomepPageList items={whatYouBring} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        What We Offer:
      </Typography>
      <HomepPageList items={whatWeOffer} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Typography variant="publicBody4Regular">
      <Typography variant="publicBody4" component="span">
        Apply now:{' '}
      </Typography>
      send your CV or short intro (even a Loom video is fine!) to{' '}
      <Typography variant="publicBody4" component="span">
        matija@spona.io{' '}
      </Typography>
      with the subject{' '}
      <Typography sx={{ fontStyle: 'italic' }} component="span">
        “SDR – Performance"
      </Typography>
    </Typography>
  </Stack>
);

export default SalesRepresentivePerformance;
